import { REDIRECT_AFTER_LOGIN } from "./types";

export default function loginRedirect( url ){
    return {
        type: REDIRECT_AFTER_LOGIN,
        payload: url
    };
}
